import Vue from 'vue'
// import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"

import axios from './axios'
import global from './globalFun'
//引入 echarts
import * as echarts from 'echarts';

Vue.prototype.$axios = axios
Vue.config.productionTip = false

//注册组件
Vue.prototype.$echarts = echarts

Vue.use(Element)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js